
import { CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { SwappableCard } from "../SwappableCard";
import { ResizableSwappableCard } from "./ResizableSwappableCard";
import { D3BarChart, D3ResponsiveContainer } from "../../charts/D3ChartUtils";

interface EmailStatsChartProps {
  emailStats: Array<{ status: string; count: number }>;
  rearrangingEnabled?: boolean;
  onRemove?: (id: string) => void;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  onResize?: (id: string, newSize: 'small' | 'medium' | 'large' | 'xlarge') => void;
}

export function EmailStatsChart({ 
  emailStats, 
  rearrangingEnabled = false, 
  onRemove,
  size = 'medium',
  onResize
}: EmailStatsChartProps) {
  // Transform data for D3 charts
  const chartData = emailStats.map(item => ({
    name: item.status,
    value: item.count
  }));

  const chartContent = (
    <>
      <CardHeader>
        <CardTitle>Email Statistics</CardTitle>
        <CardDescription>Distribution of email delivery statuses</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[200px]">
          <D3ResponsiveContainer width="100%" height="100%">
            <D3BarChart
              data={chartData}
              color="#82ca9d"
              valueFormatter={(value) => `${value} emails`}
              margin={{ top: 20, right: 30, bottom: 50, left: 40 }}
            />
          </D3ResponsiveContainer>
        </div>
      </CardContent>
    </>
  );

  if (rearrangingEnabled && onResize) {
    return (
      <ResizableSwappableCard 
        id="email-statistics" 
        size={size}
        showHandle={rearrangingEnabled} 
        showResizeControl={rearrangingEnabled}
        onRemove={onRemove}
        onResize={(newSize) => onResize("email-statistics", newSize)}
      >
        {chartContent}
      </ResizableSwappableCard>
    );
  }

  return (
    <SwappableCard id="email-statistics" showHandle={rearrangingEnabled} onRemove={rearrangingEnabled ? onRemove : undefined}>
      {chartContent}
    </SwappableCard>
  );
}
